const MODULE_NAME = "_59_by_symbol_PL_YTD";

import React, { useEffect, useState } from "react";
import axios from "axios";
import { useModuleVisibility } from "./useModuleVisibility.js";

function formatCurrency(value) {
    if (value === null || value === undefined || isNaN(value)) return "$0.00";
    return "$" + Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function BySymbolYTDPL(props) {
    // DECLARE ALL HOOKS FIRST - Before any conditional logic
    const [data, setData] = useState(null);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        setError("");

        // 🔓 Retrieve userKey from sessionStorage for decryption
        const userKey = sessionStorage.getItem("userKey");
        const params = {};
        if (userKey) {
            params.userKey = userKey;
        }

        axios.get(`${process.env.REACT_APP_API_URL}/api/by-symbol-PL-YTD`, {
            params,
            withCredentials: true,
        })
            .then(res => {
                setData(res.data);
                setLoading(false);
            })
            .catch(() => {
                setError("Could not fetch by-symbol YTD P/L data");
                setLoading(false);
            });
    }, []);

    // Check visibility based on module_name URL parameter - AFTER all other hooks
    const isVisible = useModuleVisibility(MODULE_NAME);

    // Return null if component is not visible
    if (!isVisible) return null;

    if (loading) return <div>Loading...</div>;
    if (error) return <div style={{ color: "#e63946" }}>{error}</div>;

    const summary = data?.summary || [];
    const tooltip = data?.tooltip || "";

    return (
        <div data-analytics={MODULE_NAME}>
            <h4>By Symbol YTD P/L <span title={tooltip}>🛈</span></h4>
            {summary.length === 0 ? (
                <div>No data found.</div>
            ) : (
                <table>
                    <thead>
                        <tr>
                            <th>Symbol</th>
                            <th>Description</th>
                            <th>P/L YTD</th>
                            {/* ...other columns as needed... */}
                        </tr>
                    </thead>
                    <tbody>
                        {summary.map((row, idx) => (
                            <tr key={row.Symbol || idx}>
                                <td>{row.Symbol}</td>
                                <td>{row.Description}</td>
                                <td>{formatCurrency(row.pl_ytd)}</td>
                                {/* ...other columns as needed... */}
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}

export default BySymbolYTDPL;